// extracted by mini-css-extract-plugin
module.exports = {"eolMessage":"eolMessage-module--eolMessage--1Ii_p","eolTitle":"eolMessage-module--eolTitle--3y22e","eolText":"eolMessage-module--eolText--xGu_I"};